@if (!noAccess) {
  <a class='dashboard-card text-decoration-none'>
    <span class='icon-colored pi {{icon}}'></span>
    <h5 class='text-colored'>{{ label }}</h5>
  </a>
}
